var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("p", { staticClass: "is-size-7 has-text-centered" }, [
      _vm._v("Informe o código recebido por e-mail: ")
    ]),
    _vm._v(" "),
    _c(
      "form",
      {
        ref: "form",
        staticClass: "two-factor-auth__form",
        attrs: { novalidate: "" },
        on: {
          submit: function($event) {
            $event.preventDefault()
            _vm.valid() ? _vm.login() : null
          }
        }
      },
      [
        _c(
          "sc-field",
          { staticClass: "has-text-centered" },
          [
            _c("sc-input", {
              ref: "twoFactorCode",
              attrs: {
                focus: "",
                type: "number",
                name: "twoFactorCode",
                max: "999999",
                maxlength: "8",
                placeholder: "Código recebido por e-mail",
                required: "",
                customClass: "has-text-centered"
              },
              model: {
                value: _vm.form.twoFactorCode,
                callback: function($$v) {
                  _vm.$set(_vm.form, "twoFactorCode", $$v)
                },
                expression: "form.twoFactorCode"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "sc-field",
          [
            _c("sc-button", {
              staticClass: "is-fullwidth",
              attrs: {
                type: "submit",
                theme: "primary",
                text: "Entrar",
                loading: _vm.loading
              }
            })
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "is-size-7 has-text-centered" }, [
      _c("p", [_vm._v("Não recebeu o código?")]),
      _vm._v(" "),
      _c("p", [
        _c(
          "a",
          {
            attrs: { href: "" },
            on: {
              click: function($event) {
                $event.preventDefault()
                _vm.resendTwoFactorCode($event)
              }
            }
          },
          [_vm._v("Clique aqui para reenviar.")]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c78c4c0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c78c4c0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/features/public/login/default/forms/FormTwoFactorAuth.vue
// module id = null
// module chunks = 